import { useMutation, useQuery } from '@tanstack/react-query';
import { fetchOperatorActivity, fetchOperatorActivityCsv, saveBlob } from './api';
import type { OperatorActivityReport } from './types';

export function useOperatorActivity(urn: string | undefined, enabled = true) {
  return useQuery<OperatorActivityReport>({
    queryKey: ['disruptions', urn, 'operator-activity'],
    queryFn: () => fetchOperatorActivity(urn!),
    enabled: !!urn && enabled,
    staleTime: 15_000,
  });
}

/** "Descargar actividad" — fetches the CSV and hands it to the browser as a file. */
export function useOperatorActivityDownload(urn: string) {
  return useMutation({
    mutationFn: async () => {
      const { blob, filename } = await fetchOperatorActivityCsv(urn);
      saveBlob(blob, filename);
      return filename;
    },
  });
}
